module.exports = __webpack_public_path__ + "img/bar.0ab55005.jpeg";